// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/EnderecosAdm_BuscaCepPorRuaELocationInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for
 * GET /relatorios/enderecos_adm/busca_cep_por_rua_e_location
 *
 * Read from the query string. Resolves a CEP from a customer's street and
 * location, then persists it on the customer.
 *
 * Fields (all required):
 *   cliente_id    — string, the customer id to update
 *   rua           — string, the street name to reverse-lookup
 *   location_id   — string, the locations-service id of the city/neighborhood
 *   location_type — string, "city" or "neighborhood"
 */
import { registerContract } from './validate'

export interface EnderecosAdm_BuscaCepPorRuaELocationInput {
cliente_id: string
rua: string
location_id: string
location_type: string
}

registerContract('EnderecosAdm_BuscaCepPorRuaELocationInput', {
  cliente_id:    { type: 'string',  required: true },
  rua:           { type: 'string',  required: true },
  location_id:   { type: 'string',  required: true },
  location_type: { type: 'string',  required: true },
})
